import React, { useEffect, useState } from "react";
import "./Vertical_Tracker.css";
import { Box, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import { OrderStatus } from "../../../features/master/masterSlice";

const barHeight = 350;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    height: `${barHeight}px`,
    justifyContent: "center",
    position: "relative",
    width: "20px",
  },
  progressContainer: {
    backgroundColor: "#C8C8C8",
    height: "100%",
    position: "relative",
    width: "2px",
  },
  progressBar: {
    backgroundColor: theme.palette.common.black,
    position: "absolute",
    top: 0,
    transition: "height 150ms",
    width: "2px",
    zIndex: 1,
  },
  stepsContainer: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    justifyContent: "space-between",
    position: "absolute",
  },
  step: {
    alignItems: "flex-end",
    display: "flex",
    position: "relative",
    zIndex: 2,
  },
  stepCircle: {
    height: "1rem",
    width: "1rem",
  },
  animateComplete: {
    animation: "$growShrink .3s ease",
    fontWeight: "bold !important", // Ensures text becomes bold when completed
  },
  "@keyframes growShrink": {
    "0%": { transform: "scale(1)" },
    "50%": { transform: "scale(1.2)" },
    "100%": { transform: "scale(1)" },
  },
}));

const Step = ({ complete, label }) => {
  const classes = useStyles();
  return (
    <Box className={classes.step}>
      <img
        className={clsx(classes.stepCircle, {
          [classes.animateComplete]: complete, // Animation for icon
        })}
        src={
          complete
            ? "/assets/Images/Icons/black_check.png"
            : "/assets/Images/Icons/gray_check.png"
        }
        alt={complete ? "completed step" : "incomplete step"}
      />
      <span
        style={{ left: 32, minWidth: "10rem", position: "absolute", top: -2 }}
      >
        <Typography
          variant="body2"
          className={clsx({ [classes.animateComplete]: complete })} // Bold text when complete
        >
          {label}
        </Typography>
      </span>
    </Box>
  );
};

function Vertical_Tracker({ order_status_id, percent = 76, steps = [] }) {
  const classes = useStyles();
  const [percentage, setPercentage] = useState(percent);
  const progressBarHeight = Math.floor(barHeight * (percentage / 100));

  const getStepComplete = (currPercent, currStepIdx, totalSteps) => {
    return (100 / (totalSteps - 1)) * currStepIdx <= currPercent;
  };
  const dispatch = useDispatch();
  const OrderStatusData = useSelector((state) => state.master.order_status);

  useEffect(() => {
    dispatch(OrderStatus());
  }, [dispatch]);

  useEffect(() => {
    if (OrderStatusData.length > 1) {
      const index = OrderStatusData.findIndex((s) => s.id === order_status_id);
      const percent = (100 / (OrderStatusData.length - 1)) * index;
      setPercentage(percent);
    }
  }, [OrderStatusData, order_status_id]);

  

  return (
    <div className="Vertical_Tracker">
      <Box flexDirection="column">
        <Box className={classes.root} role="progressbar">
          <Box className={classes.progressContainer}>
            <Box
              className={classes.progressBar}
              style={{ height: Math.min(barHeight, progressBarHeight) }}
            />
          </Box>
          <Box className={classes.stepsContainer}>
            {OrderStatusData.map((step, i, allSteps) => (
              <Step
                key={step.id}
                complete={getStepComplete(percentage, i, allSteps.length)}
                label={step.name}
              />
            ))}
          </Box>
        </Box>
      </Box>
    </div>
  );
}

export default Vertical_Tracker;
